import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchItems, fetchListItems } from '../../../../../hooks/useCrud';
import LoaderAndError from '../../../../../components/LoaderAndError';
import { useTranslation } from 'react-i18next';
import { usePagination } from '../../../../../hooks/usePagination';
import Pagination from '../../../../../components/Pagination';

interface UiService {
    id?: number;
    nom?: string;
    titre?: string;
    icone?: string;
    description?: string;
    slug?: string;

    createdAt?: string;
    updatedAt?: string;
}

export default function Service() {

    const [listData, setDataList] = useState<UiService[]>([]);
    const [formData, setFormData] = useState<Partial<UiService>>({});
    const [isEditing, setIsEditing] = useState(false);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(6);
    const [totalPages, setTotalPages] = useState(1);
    //fin declaration

    // pour la langue
    const { t, i18n } = useTranslation();
    // fin langue

    // declaration de la pagination
    const { paginationRange, isCurrentPage, isFirstPage, isLastPage } = usePagination({
        currentPage,
        totalPages,
    });

    // chargement de la table
    const loadlistData = async () => {
        setLoading(true);
        try {
            const res = await fetchItems<UiService>('/fetch_service_data', {
                q: search,
                page: currentPage,
                limit,
            });
            setDataList(res.data);
            setTotalPages(res.totalPages);
        } finally {
            setLoading(false);
        }
    };

    

    useEffect(() => {
        document.title = "Nos services - Swiftride";
        loadlistData();
    }, [search, currentPage, limit]);
    return (

        <div className="container-fluid py-2">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="display-10 fw-bold">
                        Nos <span className="text-primary">Programmes & Initiatives</span>
                    </h2>
                    <p className="lead text-muted">
                        Des activités dédiées à la formation, l’encadrement et l’épanouissement des jeunes basketteurs congolais.
                    </p>

                    {/* Search bar */}
                    <div className="col-lg-8 mx-auto">
                        <div className="input-group shadow-sm rounded-pill overflow-hidden">
                            <input
                                type="text"
                                className="form-control border-0 rounded-pill-start py-3 px-4 fs-6"
                                placeholder="Rechercher un programme..."
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setCurrentPage(1);
                                }}
                            />
                            <button
                                className="btn btn-primary rounded-pill-end px-4"
                                type="button"
                                onClick={() => loadlistData()}
                            >
                                <i className="fas fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="row g-4">
                    {listData.length === 0 ? (
                        <LoaderAndError
                            loading={loading}
                            error={error}
                            onClearError={() => setError(null)}
                        />
                    ) : (
                        listData.map((item) => (
                            <div className="col-md-6 col-lg-6" key={item.id}>
                                <div
                                className="project-card shadow-sm rounded-4 border-0 h-100 overflow-hidden bg-white dark:bg-gray-900 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
                                >
                                    <div className="card-body p-4 text-center">

                                        {/* ICON */}
                                        <div
                                            className="
                                                academy-icon mx-auto mb-4 
                                                bg-primary bg-opacity-10 text-primary
                                                rounded-circle d-flex align-items-center justify-content-center
                                                transition-all duration-300
                                            "
                                        >
                                            <i className={`${item.icone} fs-2`}></i>
                                        </div>

                                        {/* TITLE */}
                                        <h4 className="fw-bold mb-3 text-dark">
                                            {item.nom}
                                        </h4>

                                        {/* SUBTITLE */}
                                        <p className="text-muted mb-4 text-truncate-3">
                                            {item.titre}
                                        </p>

                                        {/* CTA */}
                                        <Link
                                            to={`/service/${item.slug}`}
                                            className="
                                                btn btn-primary rounded-pill px-4 fw-semibold 
                                                d-inline-flex align-items-center
                                                transition-all duration-300 hover-scale
                                            "
                                        >
                                            En savoir plus
                                            <i className="fas fa-arrow-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>


                <div className="text-center mt-5">
                    {/* pagination */}
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        paginationRange={paginationRange}
                        isCurrentPage={isCurrentPage}
                        isFirstPage={isFirstPage}
                        isLastPage={isLastPage}
                        onPageChange={setCurrentPage}
                        textCounter={true}
                    />
                    {/* fin pagination */}
                </div>
            </div>
        </div>

    )
}
